import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || '';
const appEnv = process.env.NEXT_PUBLIC_NODE_ENV || 'dev';

// Only start Bugsnag when an API key is provided.
// This keeps local dev and test environments silent.
if (apiKey) {
  Bugsnag.start({
    apiKey,
    plugins: [new BugsnagPluginReact()],
    releaseStage: appEnv,
    enabledReleaseStages: ['prod', 'staging'],
    redactedKeys: [/authToken/i, /authorization/i, /password/i, /token/i],
  });
}

export const isBugsnagEnabled = !!apiKey;
export default Bugsnag;
